import Grid from '@mui/material/Grid';
import { FC } from 'react';

import { GridContentProps } from '../types/grid';

const GridContent: FC<GridContentProps> = ({ children, sx }) => (
  <Grid size={1} sx={sx}>
    {children}
  </Grid>
);

export default GridContent;
